import { District } from "@/sharedTypes";
import { baseApi } from "../baseApi";

const districtTag = "District";

export const districtApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDistricts: builder.query<any, Record<string, any> | void>({
      query: (params) => {
        const searchParams = new URLSearchParams();

        if (params) {
          const { filters, pagination } = params as any;

          if (filters) {
            Object.entries(filters).forEach(([key, value]) => {
              if (value !== undefined && value !== null && value !== "") {
                searchParams.append(key, String(value));
              }
            });
          }

          if (pagination) {
            Object.entries(pagination).forEach(([key, value]) => {
              if (value !== undefined && value !== null) {
                searchParams.append(key, String(value));
              }
            });
          }
        }

        const queryString = searchParams.toString();
        return `/gw/districts${queryString ? `?${queryString}` : ""}`;
      },
      providesTags: [districtTag],
    }),
    createDistrict: builder.mutation({
      query: (payload: District) => ({
        url: "/gw/districts",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [districtTag],
    }),
    updateDistrict: builder.mutation({
      query: ({ id, ...payload }: District) => ({
        url: `/gw/districts/${id}`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: [districtTag],
    }),
    deleteDistrict: builder.mutation({
      query: (id: number) => ({
        url: `/gw/districts/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [districtTag, "LocationAlias"],
    }),
  }),
});

export const {
  useGetDistrictsQuery,
  useCreateDistrictMutation,
  useUpdateDistrictMutation,
  useDeleteDistrictMutation,
} = districtApi;
